<div class="access-denied">
  <div>
    <b>Access Denied</b>
  </div>

  <div>
    {{ summaryMessage }}
  </div>

  <sabis-ngx-button (click)="onLogoutClick()">Logout</sabis-ngx-button>
</div>
